import styles from "./AccountInfo.module.css";

function AccountInfo({ className, label1, value1, label2, value2, label3, value3, label4, value4, label5, value5 }) {
    const content = [
        { key: '1', label: label1, value: value1 },
        { key: '2', label: label2, value: value2 },
        { key: '3', label: label3, value: value3 },
        { key: '4', label: label4, value: value4 },
        { key: '5', label: label5, value: value5 },
    ]

    const contentComponent = content.map((detail) => {
        if (detail.label || detail.value) {
            return (
                <div className={className} key={detail.key}>
                    <label className={styles.label} htmlFor={`${detail.key}`}>{detail.label}</label>
                    <input type="text" id={`${detail.key}`} className='noneClass' />
                    <div className={styles.result}>{detail.value}</div>
                </div>
            )
        }
    })

    return (
        <div className={`d-flex ${styles.card}`}>
            {contentComponent}
        </div>
    )
}

export default AccountInfo;